import 'react-table/react-table.css';
import '../../../Common/css/bootstrap-rt-table.css';

import * as React from 'react';
import { AccordionItem, AccordionItemBody, AccordionItemTitle } from 'react-accessible-accordion';
import { ButtonGroup, Col, ControlLabel, Form, FormControl, FormGroup } from 'react-bootstrap';
import ReactTable from 'react-table';
import selectTableHOC from 'react-table/lib/hoc/selectTable';
import treeTableHOC from 'react-table/lib/hoc/treeTable';

import { apiClient } from '../../../Shared/React/network/api-client';
import {
    IInvoiceTableProperties, InvoiceTableState
} from '../../../Shared/React/typings/api-models/invoice/InvoiceTable';
import PagingApiRoutes from '../../../Shared/React/typings/api-routes/PagingApiRoutes';
import { AlertModal, Button, Dropdown } from './_atoms/Index';

const CheckboxTable = selectTableHOC(ReactTable);
const SelectTreeTable = selectTableHOC(treeTableHOC(ReactTable));

class InvoiceTable extends React.Component<IInvoiceTableProps, InvoiceTableState> {
  constructor(props) {
    super(props);
    const selection: string[] = [];
    this.state = {
      data: [],
      filterOptions: [],
      loading: true,
      originalData: [],
      page: 0,
      pageSize: 25,
      pivotBy: this.props.invoiceTable.pivotBy,
      selectAll: false,
      selection: selection,
      showConfirmationModal: false,
      sorted: "",
      totalPages: null,
      canFetchNewData: false,
      approveCount: 0,
      invoiceSearch: null,
    };
    this.getInvoiceData = this.getInvoiceData.bind(this);
    this.confirmApprove = this.confirmApprove.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  private _mounted = true;
  private chosenTable: any;

  public handleClose = () => {
    this.setState({ showConfirmationModal: false });
  };

  public handleShow = () => {
    this.setState({ showConfirmationModal: true });
  };

  private getOrderByString(orderByArray: any): string {
    return orderByArray.length
      ? orderByArray
          .map((element) => {
            var order = element.desc ? " desc" : " asc";
            return element.id + order;
          })
          .join(" ")
      : "";
  }

  private getInvoiceData(state): void {
    this.setState({ loading: true, canFetchNewData: false });
    apiClient
      .get(
        PagingApiRoutes.addPaging(
          this.props.invoiceTable.dataUrl,
          state.page + 1,
          this.props.invoiceTable.showPagination ? state.pageSize : null,
          this.getOrderByString(state.sorted),
          null,
        ),
      )
      .then((res: any) => {
        const selection: string[] = [];
        if (this._mounted) {
          this.props.completedFetchingNewData();

          this.setState({
            data: res.values,
            filterOptions: res.values
              .map((row) => row[this.props.invoiceTable.filterBy])
              .filter((elem, pos, arr) => {
                return arr.indexOf(elem) === pos && elem;
              }),
            loading: false,
            originalData: res.values,
            selectAll: false,
            selection: selection,
            totalPages: res.totalPages,
            canFetchNewData: true,
          });
        }
      });
  }

  private getInvoiceDataWithSearch(state): void {
    this.setState({ loading: true, canFetchNewData: false });
    apiClient
      .get(
        PagingApiRoutes.addPaging(
          this.props.invoiceTable.dataUrl,
          state.page + 1,
          this.props.invoiceTable.showPagination ? state.pageSize : null,
          this.getOrderByString(state.sorted),
          this.state.invoiceSearch,
        ),
      )
      .then((res: any) => {
        const selection: string[] = [];
        if (this._mounted) {
          this.props.completedFetchingNewData();

          this.setState({
            data: res.values,
            filterOptions: res.values
              .map((row) => row[this.props.invoiceTable.filterBy])
              .filter((elem, pos, arr) => {
                return arr.indexOf(elem) === pos && elem;
              }),
            loading: false,
            originalData: res.values,
            selectAll: false,
            selection: selection,
            totalPages: res.totalPages,
            canFetchNewData: true,
          });
        }
      });
  }

  public componentWillUnmount(): void {
    this._mounted = false;
  }

  private getNodes(data, node = []) {
    data.forEach((item) => {
      if (item.hasOwnProperty("_subRows") && item._subRows) {
        node = this.getNodes(item._subRows, node);
      } else {
        node.push(item._original);
      }
    });
    return node;
  }

  public toggleSelection = (key) => {
    key = key.replace("select-", "");
    let selection: string[] = [...this.state.selection];
    const keyIndex = selection.indexOf(key);
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)];
    } else {
      selection.push(key);
    }
    this.setState({ selection });
  };

  public toggleAll = () => {
    const selectAll = this.state.selectAll ? false : true;
    const selection: string[] = [];
    if (selectAll) {
      const wrappedInstance = this.chosenTable.getWrappedInstance();
      const currentRecords = wrappedInstance.getResolvedState().sortedData;
      const nodes = this.props.isTreeTable ? this.getNodes(currentRecords) : currentRecords;
      nodes.forEach((item) => {
        const itemToPush = this.props.isTreeTable
          ? item[this.props.invoiceTable.keyField]
          : item._original[this.props.invoiceTable.keyField];
        selection.push(itemToPush as string);
      });
    }
    this.setState({ selectAll, selection });
  };

  public isSelected = (key: string) => {
    // TODO: We should probably revisit this at some point.  I'm casting to strings specifically here because sometimes it seems that these arrays are int sometimes and strings sometimes
    // and if there is a mismatch on the data type the include fails which prevents the selection from working properly on the table.  As a workaround we can just cast the selection
    // array to strings to force the comparison since we expect a string value for the key anyways.
    const selectionStr = this.state.selection.map(String);
    return selectionStr.includes(String(key));
  };

  public isPastDue = (key: any) => {
    return new Date(key) <= new Date();
  };

  public isSubRowSelected = (element, index, array) => {
    return this.isSelected(element._original[this.props.invoiceTable.keyField]);
  };

  public isSubRowPastDue = (element, index, array) => {
    return this.isPastDue(element._original.dueDate);
  };

  public clearSelectionAndFireAction = (cb: any) => {
    const selection: string[] = [];
    this.setState(
      {
        selection: selection,
        page: 0,
        loading: true,
        canFetchNewData: true,
        showConfirmationModal: false,
      },
      () => cb,
    );
  };

  public filterData = (filterValue: string) => {
    const selection: string[] = [];
    this.setState({
      data:
        filterValue !== "View All" && filterValue !== ""
          ? this.state.originalData.filter((row) => row[this.props.invoiceTable.filterBy] === filterValue)
          : this.state.originalData,
      selection: selection,
      selectAll: false,
    });
  };

  public confirmApprove = () => {
    this.clearSelectionAndFireAction(
      this.props.approveAllStandard(this.props.invoiceTable.invoiceGroup, this.props.invoiceTable),
    );
  };

  public componentDidUpdate() {
    if (this.props.fetchNewData && this.state.canFetchNewData) {
      this.getInvoiceData(this.state);
    }
  }

  public findInvoice() {
    this.getInvoiceDataWithSearch(this.state);
  }

  public render(): JSX.Element {
    const ChosenTable = this.props.isTreeTable
      ? SelectTreeTable
      : this.props.isNormalTable
      ? ReactTable
      : CheckboxTable;

    const { approveSelected, ignoreSelected, holdSelected, approveBatch, invoiceTable, isTreeTable, hideIgnoreButton } =
      this.props;
    const { toggleSelection, toggleAll, isSelected } = this;
    const { data, selectAll, totalPages, pageSize, loading } = this.state;

    return (
      <AccordionItem expanded={!this.state.loading || (this.state.data && this.state.data.length > 0)}>
        <AlertModal
          show={this.state.showConfirmationModal}
          onHide={this.handleClose}
          headerText={invoiceTable.invoiceGroup + " Invoices"}
          bodyText={"Are you sure you want to approve all standard " + invoiceTable.invoiceGroup + " invoices?"}
          confirmButtonAction={this.confirmApprove}
          confirmButtonText="Confirm"
          showCancel={true}
          disableConfirm={this.state.loading}
        />
        <AccordionItemTitle>
          <h4 className="panel-title">{invoiceTable.title}</h4>
        </AccordionItemTitle>
        <AccordionItemBody>
          <div className="row table-top">
            <div className="col-md-4">
              <ButtonGroup
                style={{
                  display: invoiceTable.showApproveButton || !hideIgnoreButton ? "block" : "none",
                }}
              >
                <Button
                  onClick={(): void => {
                    this.clearSelectionAndFireAction(approveSelected(this.state.selection, invoiceTable));
                  }}
                  text="Approve Selected"
                  className="cyan-btn"
                  show={invoiceTable.showApproveButton}
                  disabled={this.state.selection.length <= 0}
                />
                <Button
                  onClick={(): void => {
                    this.clearSelectionAndFireAction(ignoreSelected(this.state.selection, invoiceTable));
                  }}
                  text={invoiceTable.ignoreText}
                  className="btn-danger"
                  show={hideIgnoreButton ? false : true}
                  disabled={this.state.selection.length <= 0}
                />
                <Button
                  onClick={(): void => {
                    this.clearSelectionAndFireAction(holdSelected(this.state.selection, invoiceTable));
                  }}
                  text="Hold Selected"
                  className="btn-primary"
                  show={invoiceTable.tableName === "residentialStandardInvoices"}
                  disabled={this.state.selection.length <= 0}
                />
              </ButtonGroup>
            </div>
            {invoiceTable.tableName === "residentialStandardInvoices" && (
              <div className="col-md-3">
                <Form horizontal>
                  <FormGroup controlId="formApproveBatch">
                    <Col componentClass={ControlLabel} sm={6}>
                      Invoices to Approve
                    </Col>
                    <Col sm={4}>
                      <FormControl
                        type="number"
                        min="1"
                        max="99999"
                        value={this.state.approveCount}
                        onChange={(event) => {
                          this.setState({
                            approveCount: event.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={2}>
                      <Button
                        className="cyan-btn"
                        show={true}
                        disabled={this.state.loading || this.state.approveCount <= 0 || this.state.approveCount > 99999}
                        type="submit"
                        text="Approve"
                        onClick={() =>
                          this.clearSelectionAndFireAction(
                            approveBatch(this.state.approveCount, this.props.invoiceTable),
                          )
                        }
                      />
                    </Col>
                  </FormGroup>
                </Form>
              </div>
            )}
            {invoiceTable.tableName === "residentialStandardInvoices" && (
              <div className="col-md-3">
                <Form horizontal>
                  <FormGroup controlId="formSearchInvoice">
                    <Col componentClass={ControlLabel} sm={4}>
                      Search
                    </Col>
                    <Col sm={6}>
                      <FormControl
                        type="string"
                        maxLength="54"
                        value={this.state.invoiceSearch}
                        onChange={(event) => {
                          this.setState({
                            invoiceSearch: event.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col sm={2}>
                      <Button
                        className="green-btn"
                        show={true}
                        disabled={this.state.loading || this.state.invoiceSearch == null}
                        type="submit"
                        text="Search"
                        onClick={() => this.findInvoice()}
                      />
                    </Col>
                  </FormGroup>
                </Form>
              </div>
            )}
            <div className="col-md-2 pull-right">
              <Button
                onClick={this.handleShow}
                text="Approve All Standard"
                className="cyan-btn pull-right"
                show={invoiceTable.showApproveAllButton}
                disabled={!this.state.data || this.state.data.length == 0 || this.state.loading}
              />
              <Dropdown
                onChange={(event) => {
                  this.filterData(event.target.value);
                }}
                options={this.state.filterOptions}
                title="Hold Reason"
                show={invoiceTable.filterable}
              />
            </div>
          </div>
          {(this.state.data && this.state.data.length > 0) || this.state.loading ? (
            <div>
              <ChosenTable
                className="table table-bordered table-hover table-striped table-striped-cyan"
                columns={invoiceTable.columns}
                data={data}
                defaultPageSize={pageSize}
                freezeWhenExpanded={isTreeTable ? true : false}
                getTdProps={(state, rowInfo) => {
                  var selected = false;
                  var pastDue = false;
                  if (isTreeTable) {
                    if (!rowInfo.subRows) {
                      selected = rowInfo ? this.isSelected(rowInfo.original[invoiceTable.keyField]) : false;
                      pastDue = rowInfo ? this.isPastDue(rowInfo.original.dueDate) : false;
                    } else {
                      selected = rowInfo.subRows.every(this.isSubRowSelected);
                      pastDue = rowInfo.subRows.every(this.isSubRowPastDue);
                    }
                  }
                  return {
                    style: {
                      backgroundColor: selected ? "#b3e2f5" : null,
                      color: pastDue ? "#ff4c4c" : "inherit",
                    },
                  };
                }}
                getTrProps={(state, rowInfo) => {
                  const selected = rowInfo ? this.isSelected(rowInfo.original[invoiceTable.keyField]) : false;
                  const pastDue = rowInfo ? this.isPastDue(rowInfo.original.dueDate) : false;
                  return {
                    style: {
                      backgroundColor: selected ? "#b3e2f5" : null,
                      color: pastDue ? "#ff4c4c" : "inherit",
                    },
                  };
                }}
                isSelected={isSelected}
                keyField={invoiceTable.keyField}
                loading={loading}
                manual
                minRows={0}
                onFetchData={this.getInvoiceData}
                pages={totalPages}
                pageSizeOptions={[25, 100, 250, 1000, 10000]}
                pivotBy={invoiceTable.invoiceGroup !== "Commercial" && isTreeTable ? invoiceTable.pivotBy : undefined}
                ref={(r) => (this.chosenTable = r)}
                selectAll={selectAll}
                selectType="checkbox"
                showPageJump={false}
                showPagination={invoiceTable.showPagination}
                SubComponent={(row) => {
                  if (invoiceTable.invoiceGroup !== "Commercial") {
                    var subRow = [];
                    subRow.push(row.original);
                    return (
                      <div style={{ padding: "15px" }}>
                        <div className="col-md-6 col-md-offset-3">
                          <em>Charges</em>
                          <ReactTable
                            data={subRow}
                            columns={invoiceTable.subComponentColumns}
                            defaultPageSize={1}
                            showPagination={false}
                          />
                        </div>
                      </div>
                    );
                  } else if (invoiceTable.title !== "Standard") {
                    return (
                      <div style={{ padding: "15px" }}>
                        <div className="col-md-12">
                          <em>Commercial Accounts</em>
                          <ReactTable
                            data={row.original.stagedInvoices}
                            columns={invoiceTable.subComponentColumns}
                            defaultPageSize={row.original.stagedInvoices.length}
                            showPagination={false}
                          />
                        </div>
                      </div>
                    );
                  }
                  return null;
                }}
                toggleAll={toggleAll}
                toggleSelection={toggleSelection}
              />
              <ButtonGroup
                style={{
                  display: invoiceTable.showApproveButton || !hideIgnoreButton ? "inline-block" : "none",
                }}
              >
                <Button
                  onClick={(): void => {
                    this.clearSelectionAndFireAction(approveSelected(this.state.selection, invoiceTable));
                  }}
                  text="Approve Selected"
                  className="cyan-btn"
                  show={invoiceTable.showApproveButton}
                  disabled={this.state.selection.length <= 0}
                />
                <Button
                  onClick={(): void => {
                    this.clearSelectionAndFireAction(ignoreSelected(this.state.selection, invoiceTable));
                  }}
                  text={invoiceTable.ignoreText}
                  className="btn-danger"
                  show={hideIgnoreButton ? false : true}
                  disabled={this.state.selection.length <= 0}
                />
              </ButtonGroup>
            </div>
          ) : (
            <h4>There are no records to display at this time</h4>
          )}
        </AccordionItemBody>
      </AccordionItem>
    );
  }
}

export interface IInvoiceTableProps {
  invoiceTable: IInvoiceTableProperties;
  approveSelected: any;
  ignoreSelected: any;
  holdSelected?: any;
  approveAllStandard?: any;
  isTreeTable: boolean;
  isNormalTable?: boolean;
  hideIgnoreButton?: boolean;
  fetchNewData: boolean;
  fetchingNewData: any;
  completedFetchingNewData: any;
  approveBatch?: any;
}

export default InvoiceTable;
